import '../css/common.less';
import '../css/panel-common.less';
import '../css/custom.less';

import {
    createContainer,
    // unauthFooter
} from './helper/template'; // 版型

import '../web-components/message-bar/message-bar';

/* ----- axios get data ----- */
import {
    getAnnouncement,
    sendApiRequest,
    globalErrorHandler,
    getManagersMenu
} from './api';

// top header
import {Header} from '../components/header/header';

// 使用者資料、使用者選單
import {User} from '../components/user/user';

// 批次停用酒測器 (cem only)
// import {DeviceDeBatch} from '../components/deviceDebatch/deviceDebatch';

// dialog box，用來顯示 API 錯誤訊息
import {dialogBox} from '../components/dialogBox/dialogBox';

// 裝置月報表
import {deviceUsageReport} from '../components/deviceUsageReport/deviceUsageReport';

// 授權碼報表
import {licenseUsageReport} from '../components/licenseUsageReport/licenseUsageReport';

// 庫存警示
import {inventoryAlert} from '../components/inventoryAlert/inventoryAlert';

// 語言切換選單
import '../web-components/language-selector/language-selector';

// page-footer
import '../web-components/page-footer/page-footer';

// 語言檔 v2 (重新翻譯的版本，漸進導入，逐步替換舊的語言檔)
import {initI18n, t as _t} from '../i18n/loader';

const dayjs = require('dayjs');
const customParseFormat = require('dayjs/plugin/customParseFormat');
dayjs.extend(customParseFormat);

/* ----- Start ----- */
async function start(){

    // 決定區域代碼、顯示語言、客製化樣式
    await environment();

    // 根據 window.page 變數值來判斷要顯示頁面內容
    // 如果此值不存在，就指定為 basic 基本版型 (例如 terms, rules 等純文字頁面）
    const currPage = (window.page)? window.page : 'basic';

    // 在 body 加上 'window.page' className
    document.body.classList.add(currPage);

    // mission-section for APP (JWT token only)
    if(currPage === 'dashboard-mission'){
        import(/* webpackChunkName: "dashboard-mission" */ '../pages/dashboard-mission/dashboard-mission').then((module) => {
            const Module = module.default;
            const instance = new Module();
        });
        return;
    }
    if(currPage === 'dashboard-duty'){
        import(/* webpackChunkName: "dashboard-duty" */ '../pages/dashboard-duty/dashboard-duty').then((module) => {
            const Module = module.default;
            const instance = new Module();
        });
        return;
    }

    // 建立主 header (header.header 是由 blade 所建)
    let landing = false;
    switch(currPage){
        case 'landing':
        case 'checklist':
        case 'manual':
        case 'calibration-report':
        case 'tcat-duty-report':
        case 'records-card-view':
            landing = true;
            break;
    }
    const mainHeader = new Header(
        document.querySelector('header.header'),
        landing
    );

    // 取得系統公告內容
    let announceData = null;
    try {
        announceData = await getAnnouncement().then(res => res.data);
    } catch(error){
        console.log(error);
    }
    showAnnouncement(announceData);

    // 適用所有頁面的 event handler
    globalEvents();

    // dialog box，用來顯示 API 錯誤訊息
    // hint: false, scroll: false
    window.apiErrBox = new dialogBox('apiErrBox', false, false);
    apiErrBoxInit();

    // message box，只有關閉按鈕，用來顯示比較單純的訊息
    window.msgBox = new dialogBox('msgBox', false, false);
    msgBoxInit();

    // 根據目前頁面，執行相對應的動作
    showContent(currPage);
}

start();
// if(window.env === 'dev'){
//     timeCheckTest();
// }

// ----- 適用所有頁面的 event handler ----- //
function globalEvents(){

    document.body.addEventListener('change', (event) => {
        // 移除 text input 前後空白
        if(event.target.tagName === 'INPUT'){
            const target = event.target;
            if(target.type === 'text' || target.type === 'email'){
                target.value = target.value.trim();
            }
        }

    });

    document.body.addEventListener('click', (e) => {

        const passwordToggle = e.target.closest('.password-input-toggle');
        if(passwordToggle){
            // 密碼眼睛切換
            passwordInputToggle(passwordToggle);
        }

    });

}

// === 密碼眼睛切換 === //
function passwordInputToggle(passwordToggle){

    const current = passwordToggle.dataset.current;
    const parent = passwordToggle.closest('.password-input-wrapper');
    const input = parent.querySelector('input');

    if(!input){
        return;
    }

    if(current === 'show'){
        // icon 眼睛張開，按下去後將 input 改為 text
        passwordToggle.dataset.current = 'hide';
        input.type = 'text';
    } else {
        // icon 眼睛閉起，按下去後將 input 恢復為 password
        passwordToggle.dataset.current = 'show';
        input.type = 'password';
    }

}

/* ---------- 取得一些初始資料後，顯示各頁面內容 ---------- */
async function showContent(page){

    // 設定基本的 app 下載按鈕連結，提供未登入時使用
    // 登入後改為 js 控制按鈕與選單
    // const btnAppDwn = document.querySelector('#btnAppDwn');
    // if(btnAppDwn){
    //     btnAppDwn.href = window.langTxt.appDownload.regular.link;
    //     btnAppDwn.setAttribute('target', '_blank');
    // }

    // 取得使用者登入資訊
    let userInfoData = null;
    try {
        document.body.classList.add('loading');

        userInfoData = await sendApiRequest('post', '/user/info', null)
            .then(res => res.data);

    } catch(error){
        globalErrorHandler(error);
    } finally {
        document.body.classList.remove('loading');
    }

    // 未登入
    // authcheck: false ​​
    // user: null

    // 已登入
    // authcheck: true
    // jwt: JWT token
    // user: 使用者資訊，包含綁定的管理權限等

    // 用來儲存實體化 User 物件後整理的使用者資料
    let userRoleInfo = null;

    if(!userInfoData.data.authcheck){

        // 是否顯示「未登入時的 page-footer」
        let showPageFooter = true;
        // 是否顯示「未登入時的語言切換選單」
        let showLanguageSelector = true;

        // ----- 使用者未登入 ----- //
        switch(page){
            // 說明文件或靜態文字頁
            case 'document':
            case 'basic':
            // 註冊登入等相關頁面
            case 'login':
            case 'signup':
            case 'forgotpw':
            case 'resetpw':
                // 不跳轉到 login
                break;

            // 登入與否都可以看到的獨立內容頁
            case 'landing':
            case 'checklist':
            case 'manual':
                // 不跳轉到 login
                // 顯示 page-footer / 語言切換選單
                showPageFooter = false;
                showLanguageSelector = false;
                break;

            default:
                // 其他頁面都需要登入後才能看到內容，所以必須直接顯示 login 畫面
                // 移除原本的 page class
                document.body.classList.remove(page);
                // 顯示 login 畫面
                page = 'login';
                // 將網址替換為 login
                window.history.replaceState(null, null, '/login');
                document.body.classList.add(page);
        }

        if(showLanguageSelector){
            const languageSelector = document.createElement('language-selector');
            const extraBtnWpr = document.querySelector('#extraBtnWpr');
            if(extraBtnWpr){
                extraBtnWpr.appendChild(languageSelector);
                languageSelector.setData = window.t('languageSelector');
            }
        }

        if(window.ty3000){
            showPageFooter = false;
        }

        if(showPageFooter){
            const pageFooter = document.createElement('page-footer');
            document.body.appendChild(pageFooter);
            pageFooter.setData = window.t('pageFooter');
        }

    } else {
        // ----- 使用者登入後 ----- //

        /* --- 實體化 User 物件 --- */
        window.mainUser = new User(userInfoData);

        // 整理後的使用者登入狀態與資訊
        userRoleInfo = window.mainUser.userRoleInfo;

        // 若使用者已經登入但尚未綁定任何權限，顯示 user-match 頁的內容
        if(userRoleInfo.allRoles === null){

            const path = window.location.pathname;

            if(path === '/dev' && window.env === 'dev'){
                // dev 頁除外
            } else {
                // 移除原本的 page class
                document.body.classList.remove(page);
                page = 'user-match';
                // 將網址替換為 user/match
                window.history.replaceState(null, null, '/user/match');
                document.body.classList.add(page);
            }

        } else {
            // 如果使用者有權限，但誤入 /user/match 頁
            if(window.page === 'user-match'){
                // 強制轉換到首頁
                location.replace('/');
            }
        }

        // 先取得一次 managers/menu 資料 (儲存到 window 變數中)
        // 必須在 User 實體之後，因為需要根據不同權限取得對應的資料
        window.managersMenuData = await getManagersMenu();
    }

    const roleCode = (userRoleInfo && userRoleInfo.role)? userRoleInfo.role : null;
    const roleId = (userRoleInfo && userRoleInfo.id)? userRoleInfo.id : null;

    // 顯應頁面對應的內容
    switch (page) {

        // case 'basic':
            // unauthFooter(); // 未登入時的 footer
            // break;

        // 登入頁
        case 'login':
            document.body.classList.add('unauth');
            import(/* webpackChunkName: "signup" */ '../components/account/login-v2').then((module) => {
                const Module = module.default;
                const loginModal = new Module();
                // unauthFooter(); // 未登入時的 footer
            });
            break;

        // 註冊頁
        case 'signup':
            document.body.classList.add('unauth');
            import(/* webpackChunkName: "signup" */ '../components/account/signup-v2').then((module) => {
                const SignupModal = module.default;
                const signupModal = new SignupModal();
                // unauthFooter(); // 未登入時的 footer
            });
            break;

        // 忘記密碼
        case 'forgotpw':
            document.body.classList.add('unauth');
            import(/* webpackChunkName: "forgotpw" */ '../components/account/forgotpw').then((module) => {
                const ForgotPwModal = module.default;
                const forgotPwModal = new ForgotPwModal();
                // unauthFooter(); // 未登入時的 footer
            });
            break;

        // 重設密碼
        case 'resetpw':
            document.body.classList.add('unauth');
            import(/* webpackChunkName: "resetpw" */ '../components/account/resetpw').then((module) => {
                const ResetPwModal = module.default;
                const resetPwModal = new ResetPwModal();
                // unauthFooter(); // 未登入時的 footer
            });
            break;

        // 權限綁定
        case 'user-match':
            import(/* webpackChunkName: "resetpw" */ '../components/user/match').then((module) => {
                const UserMatch = module.default;
                const userMatch = new UserMatch();
                // unauthFooter(); // 未登入時的 footer
            });
            break;

        // 舊的資訊統計頁 (裝置狀態總覽)
        // case 'panel-info':
        //     createContainer(roleCode, roleId);
        //     import(/* webpackChunkName: "info" */ '../pages/info/info').then((module) => {
        //         const Info = module.default;
        //         const panelInfo = new Info(roleCode, roleId);
        //     });
        //     break;

        // 公司列表
        case 'panel-coms':
            createContainer(roleCode, roleId);
            import(/* webpackChunkName: "coms" */ '../pages/coms/coms').then((module) => {
                const Coms = module.default;
                const panelComs = new Coms(roleCode, roleId);
            });
            break;

        // 站點列表
        case 'panel-sites':
            createContainer(roleCode, roleId);
            import(/* webpackChunkName: "sites" */ '../pages/sites/sites').then((module) => {
                const Sites = module.default;
                const panelSites = new Sites(roleCode, roleId);
            });
            break;

        // APP 用戶端
        case 'panel-edges':
            createContainer(roleCode, roleId);
            import(/* webpackChunkName: "edges" */ '../pages/edges/edges').then((module) => {
                const Edges = module.default;
                const panelEdges = new Edges('edges', roleCode, roleId);
            });
            break;

        // 裝置管理
        case 'panel-devices':
            createContainer(roleCode, roleId);
            import(/* webpackChunkName: "devices" */ '../pages/devices/devices').then((module) => {
                const Devices = module.default;
                const panelDevices = new Devices('devices', roleCode, roleId, {
                    exportData: true
                });
            });
            break;

        // 管理者列表
        case 'panel-managers':
            createContainer(roleCode, roleId);
            import(/* webpackChunkName: "managers" */ '../pages/managers/managers').then((module) => {
                const Managers = module.default;
                const panelManagers = new Managers('managers', roleCode, roleId, {
                    exportData: true
                });
            });
            break;

        // 受測者列表
        case 'panel-testers':
            createContainer(roleCode, roleId);
            import(/* webpackChunkName: "testers" */ '../pages/testers/testers').then((module) => {
                const Testers = module.default;
                const panelTesters = new Testers('testers', roleCode, roleId, {
                    exportData: true
                });
            });
            break;

        // 檢核表
        case 'panel-inspection':
            createContainer(roleCode, roleId);
            import(/* webpackChunkName: "inspection" */ '../pages/inspection/inspection').then((module) => {
                const Module = module.default;
                const panel = new Module(roleCode, roleId);
            });
            break;

        // 紀錄查詢
        case 'panel-records':
            createContainer(roleCode, roleId);
            import(/* webpackChunkName: "records" */ '../pages/records/records').then((module) => {
                const Records = module.default;
                const panelRecords = new Records('records', roleCode, roleId, {
                    fetchListData: false
                });
            });
            break;

        // dashboard prototype
        // case 'dashboard-proto':
        //     createContainer(roleCode, roleId);
        //     import(/* webpackChunkName: "dashboard" */ '../pages/dashboard-proto/dashboard').then((module) => {
        //         const Dashboard = module.default;
        //         const page = new Dashboard(roleCode, roleId);
        //     });
        //     break;

        // dashboard (正式版)
        case 'dashboard':
            createContainer(roleCode, roleId);
            import(/* webpackChunkName: "dashboard" */ '../pages/dashboard/dashboard').then((module) => {
                const Dashboard = module.default;
                const page = new Dashboard(roleCode, roleId);
            });
            break;

        /* ----- 以下為獨立的頁面，版型跟其他頁面不同 ----- */
        // landing page (/landing)
        case 'landing':
            import(/* webpackChunkName: "landing" */ './landing').then((module) => {
                const init = module.default;
                init();
            });
            break;

        // 檢核表 (/checklist)
        case 'checklist':
            import(/* webpackChunkName: "checklist" */ '../checklist/checklist').then((module) => {
                // 獨立的頁面都套用 landing 的基本樣式
                document.body.classList.add('landing');
                const Module = module.default;
                const checklist = new Module();
            });
            break;

        // 站點使用須知 (/manual)
        case 'manual':
            import(/* webpackChunkName: "manual" */ '../pages/manual/manual').then((module) => {
                // 獨立的頁面都套用 landing 的基本樣式
                document.body.classList.add('landing');
                const Module = module.default;
                const Manual = new Module();
            });
            break;

        // 校正報告 (/calibration-report)
        case 'calibration-report':
            import(/* webpackChunkName: "calibrationReport" */ '../components/calibrationReport/calibrationReport').then((module) => {
                // 獨立的頁面都套用 landing 的基本樣式
                document.body.classList.add('landing');
                const Module = module.default;
                const report = new Module();
            });
            break;

        // 黑貓表報 (/tcat-duty-report)
        case 'tcat-duty-report':
            import(/* webpackChunkName: "tcatDutyReport" */ '../components/tcatDutyReport/tcatDutyReport').then((module) => {
                // 獨立的頁面都套用 landing 的基本樣式
                document.body.classList.add('landing');
                const Module = module.default;
                const report = new Module();
            });
            break;

        // 紀錄查詢卡片模式
        case 'records-card-view':
            import(/* webpackChunkName: "recordsCardView" */ '../pages/records-card-view/records-card-view').then((module) => {
                // 獨立的頁面都套用 landing 的基本樣式
                document.body.classList.add('landing');
                const Module = module.default;
                const report = new Module();
            });
            break;

        // 跨公司查詢的範例頁面 (for 奇美)
        // case 'chimei':
        // import(/* webpackChunkName: "chimei" */ '../pages/chimei/chimei').then((module) => {
        //     const Module = module.default;
        //     const chimei = new Module();
        // });
        // break;
    }

    // 以下放在 header 的獨立功能按鈕，用 appendChild 的方式插入
    // 所以會按照執行的先後順序，由左到右排列
    const extraBtnWpr = document.getElementById('extraBtnWpr');

    // 插入校正報告連結
    calibrationReportButton(roleCode, extraBtnWpr);

    if(roleCode === 'cem' || roleCode === 'dm'){
        // 裝置月報表 device usage report
        const deviceUsageReportModal = new deviceUsageReport(
            extraBtnWpr, userRoleInfo.role
        );
        // 授權碼報表 license usage report
        const LURModal = new licenseUsageReport(
            extraBtnWpr, userRoleInfo.role
        );
    }

    if(roleCode === 'cem'){
        // 批次停用酒測器
        // const deviceDeBatchBox = new DeviceDeBatch(
        //     userRoleInfo.id, extraBtnWpr
        // );
        // 庫存警示
        window.inventoryAlertBox = new inventoryAlert(extraBtnWpr);
    }

}

/* ----- 顯示系統公告 ----- */
function showAnnouncement(Data){

    if(Data.visibility !== 'visible'){
        return;
    }

    // 公告日期
    const annoDate = dayjs(Data.date, ['YYYY-MM-DD', 'YYYY-M-D']);
    // 公告日期加 1 天
    const endDate = annoDate.add(1, 'day');

    const today = dayjs();

    if(today.isAfter(endDate, 'day')){
        // 已經超過公告日期，後續程序不執行
        return;
    }

    const Html =
    `<div class="icon"><svg>
        <use xlink:href="/assets/sprites/sprites_solid.svg#info"></use>
    </svg></div>
    <p>${Data.content}</p>`;

    const container = document.getElementById('sysAnnowpr');
    if(container){
        container.innerHTML = Html;
    }

}

/* ----- apiErrBox event handler ----- */
function apiErrBoxInit(){
    try {
        const box = window.apiErrBox;

        const buttonTxt = window.langTxt['apiMsg']['button'];
        // 重新載入頁面
        box.set_confirmBtnTxt(buttonTxt['reload']);
        // 關閉
        box.set_cancelBtnTxt(buttonTxt['close']);

        const container = box.container;

        container.addEventListener('click', (event) => {

            if(event.target.id === 'apiErrBoxcancel'){
                box.close();
            }

            if(event.target.id === 'apiErrBoxconfirm'){
                location.reload();
            }

        });

    } catch(error){
        console.log(error);
    }
}

/* ----- message box，只有關閉按鈕，單純顯示訊息 ----- */
function msgBoxInit(){

    const container = window.msgBox.container;

    window.msgBox.set_btnwpr(
        `<div class="btn close" id="msgBoxclose">
            ${window.t('common.button.close')}
        </div>`
    )

    container.addEventListener('click', (event) => {
        if(event.target.id === 'msgBoxclose'){
            window.msgBox.close(); // 預設關閉時會清除訊息內容
        }
    });

}

// ----- 決定區域代碼、顯示語言、客製化樣式 ----- //
async function environment(){
    // 在 environment.js 中判斷
    // 以下三組為互相獨立的設定，不互相影響
    // 1. UI 顯示語言：window.currLang tc || jp || en
    // 2. 客製化樣式：window.customSetting
    // 3. 區域代碼：window.countryCode TW || JP

    // 其他
    // 1. 是否為測試環境 window.env
    // 2. 目前所在的頁面 window.page (在 laravel blade 中指定)
    // 3. 第一版語言檔 window.langTxt

    // const host = window.location.hostname;

    const path = window.location.pathname;

    const isWebviewPage = [
        '/dashboard-mission',
        '/dashboard-duty'
    ].some((keyword) => {
        return path.startsWith(keyword);
    });

    // for webview layout
    if(isWebviewPage){
        document.documentElement.classList.add('webview');
    }

    // Mobile 樣式 body.mobile
    const isMobile = /iPhone|Android|Mobile|iPad|iPod/i.test(navigator.userAgent);
    if(isMobile){
        document.body.classList.add('mobile');
    }

    const body = document.body;

    // TEST
    // window.customSetting = 'tcat';
    // window.dutyTest = true;

    const customSetting = window.customSetting ?? null;

    if(customSetting){
        // 在 body 加上客製化樣式的 className，例如 body.acerits
        body.classList.add(customSetting);
        // body.dataset.custom = customSetting;

        // 特定客製化樣式共用 default 樣式設定
        switch(customSetting){
            case 'tcat':
                body.classList.add('default');
                break;
        }

    } else {
        // 預設樣式為 body.default
        body.classList.add('default');
        // body.dataset.custom = 'default';
    }

    // 註冊與登入方式 email (預設值) || empNr (限定工號+統編)
    let loginType = 'email';
    const empNrList = ['tcat'];
    if(empNrList.includes(customSetting)){
        loginType = 'empNr';
    }
    window.loginType = loginType;

    // TEST
    // window.serverInfo.app_env = 'production';

    // 正式 || 測試環境
    // 只有在測試環境會等於 'dev'，其它環境都是 undefined
    switch(window.serverInfo.app_env){
        case 'development':
        case 'local':
        case 'testing':
        case 'staging':
            body.classList.add('dev');
            body.dataset.env = 'dev';
            window.env = 'dev';
            break;
    }

    const currLang = window.currLang

    body.dataset.lang = currLang;
    body.classList.add(currLang);

    // 語言檔 v1
    const _langTxt = await import(`../lang/${currLang}.js`);
    window.langTxt = _langTxt.default;

    // 語言檔 v2: i18n
    const i18n = await initI18n(currLang);
    window.t = _t;

    customComponents(customSetting);
}

// 插入校正報告連結
function calibrationReportButton(roleCode, wrapper){

    if(roleCode !== 'cem'){
        return;
    }

    const elem = document.createElement('a');
    elem.className = 'btn-control';
    elem.innerHTML =
    `<svg><use xlink:href="/assets/sprites/sprites_solid.svg#clipboard-check"></use></svg>${window.t('calibrationReport.title.short')}`;

    const currPath = window.location.pathname;
    const path = '/calibration-report';

    if(currPath !== path){
        elem.target = '_blank';
    }

    elem.rel = 'noopener noreferrer';
    elem.href = path;

    wrapper.appendChild(elem);
}

/*
function timeCheckTest(){

    clearTimeout(window.testing);

    try {
        // 開始時間
        const startTime = dayjs();

        sendApiRequest('post', '/api/app/timecheck', null)
            .then(res => res.data)
            .then((data) => {
                // console.log(data.data.now);

                // 結束時間
                const endTime = dayjs();
                const diff = endTime.diff(startTime);
                console.log(diff);

                window.testing = setTimeout(() => {
                    timeCheckTest();
                }, 1000);

            });
    } catch(error){
        console.log(error);
    }

}
*/

// ===== 特定的客製化元件 ===== //
function customComponents(custom){

    if(!custom){
        custom = 'default';
    }

    // 目前暫時只有 message-bar
    const data = window.t(`MessageBar.${custom}`);

    if(data && data.display){
        const messageBar = document.createElement('message-bar');
        document.body.appendChild(messageBar);

        messageBar.setAttribute('position', data.position);
        messageBar.setData = data.content;

        document.body.classList.add(`message-bar-${data.position}`);
    }

}
